/**
 * Skip login reCAPTCHA when:
 * - Vercel Preview (`VERCEL_ENV` / `NEXT_PUBLIC_VERCEL_ENV` === preview)
 * - Vercel CLI dev (`vercel dev`, typically development)
 * - Vercel deployment URLs (`*.vercel.app`) used for QA/pre-production checks
 */
const normalizeHost = (host = '') =>
    String(host).split(',')[0].trim().toLowerCase()

export function shouldSkipLoginRecaptcha(host) {
    const vercelEnv =
        process.env.VERCEL_ENV ?? process.env.NEXT_PUBLIC_VERCEL_ENV
    if (vercelEnv === 'preview' || vercelEnv === 'development') {
        return true
    }

    const requestHost = normalizeHost(
        host || (typeof window !== 'undefined' ? window.location.hostname : ''),
    )

    if (requestHost.endsWith('.vercel.app')) {
        return true
    }

    return false
}
